import { DialogComponent } from "@theme/dialog";

/**
 * DAC customization: video testimonial modal; autoplay on open when data-autoplay is set
 * (mirrors _dac-slide-video video_autoplay). Pause-on-close via DialogCloseEvent.
 */
class DacVideoTestimonialDialog extends DialogComponent {
  async showDialog() {
    super.showDialog();

    if (!this.hasAttribute("data-autoplay")) return;

    const media = this.querySelector("deferred-media");
    if (!media || typeof media.showDeferredMedia !== "function") return;

    try {
      await media.showDeferredMedia();
      if (typeof media.playMedia === "function") {
        await media.playMedia();
      }
    } catch (error) {
      console.warn("DAC video testimonial: failed to start media", error);
    }
  }
}

if (!customElements.get("dac-video-testimonial-dialog")) {
  customElements.define("dac-video-testimonial-dialog", DacVideoTestimonialDialog);
}
